import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import axios from "axios";
import { Link } from "react-router-dom";
import { useHistory, useParams } from "react-router-dom";
import { endpoints } from "../../../services/apiurl";
import { Card } from "@mui/material";
import PageTitle from "../../UI/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { InfinitySpin } from "react-loader-spinner";

const SliderDetail = () => {
  let history = useHistory();
  let { restro_id } = useParams();
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [items, setItems] = useState([]);
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);

  useEffect(() => {
    fetchData(1, perPage);
  }, [perPage]);

  const columns = [
    {
      name: "HEADING",
      selector: (row) => row.heading,
      // width: '200px'
    },
    {
      name: "STATUS",
      selector: (row) => (row.status == 1 ? "Active" : "Inactive"),
      // width: '200px'
    },
    {
      name: "ACTION",
      cell: (row) => (
        <div>
          {" "}
          <Link to={`/dashboard/editslider/${row.id}`}>
            {" "}
            <EditIcon />{" "}
          </Link>
          <Link
            className="error"
            style={{ marginTop: "0px", marginLeft: "0px" }}
            onClick={() => {
              confirmAlert({
                title: "Confirm",
                message: "Do you really want to delete?",
                buttons: [
                  {
                    label: "Yes",
                    onClick: () => removeContactHandler(row.id),
                  },
                  {
                    label: "No",
                    onClick: () => {},
                  },
                ],
              });
            }}
          >
            <DeleteIcon />
          </Link>
        </div>
      ),
      selector: (row) => row.id,
      // width: '200px'
    },
  ];

  const removeContactHandler = async (id) => {
    await axios.post(endpoints.deleteSlider, { id }).then((response) => {});
    const newContactList = items.filter((contact) => {
      return contact.id !== id;
    });
    setItems(newContactList);
  };

  const fetchData = async (page, per_page) => {
    await axios
      .post(endpoints.getSlider, {
        page,
        per_page,
      })
      .then(
        (response) => {
          setIsLoaded(true);
          setItems(response.data.data);
          setTotalRows(response.data.total);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  };

  const handlePageChange = (page) => {
    fetchData(page, perPage);
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    setPerPage(newPerPage);
  };

  if (error) {
    return <div>Error: {error.message}</div>;
  } else if (!isLoaded) {
    return (
      <div className="spinner">
        <InfinitySpin
          visible={true}
          width="200"
          color="#fbaa1a"
          ariaLabel="infinity-spin-loading"
        />
      </div>
    );
  } else {
    return (
      <div className="App">
        <PageTitle
          title="Slider List"
          linkid={restro_id}
          linkurl="/dashboard/addslider"
          linkTitle="Add Slider"
        />
        <Card className="px-3 py-3">
          <DataTable
            columns={columns}
            data={items}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
          />
        </Card>
      </div>
    );
  }
};

export default SliderDetail;
